import React from 'react';

import {
  Dialog,
  DialogHeader,
  DialogBody
} from './Dialog';

/* This dialog embeds all actions within it's children, ultimately allowing
   it's children to pass up to the parent (no dialog in the middle) */
class ProgramDialog extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      show: this.props.show,
      caption: this.props.caption,
      width: this.props.width,
      height: this.props.height,
      tab: this.props.currenttab === undefined ? 0 : this.props.currenttab,
      hasError: false,
      error: {},
      info: {}
    };

    this.onCancel = this.onCancel.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      show: nextProps.show,
      caption: nextProps.caption,
      width: nextProps.width,
      height: nextProps.height,
      tab: nextProps.currenttab
    } );
  }

  // This tells the header to exit the dialog
  onCancel( e ) {
    if( this.props.onCancel !== undefined ){
      this.props.onCancel( e );
    }
  }

  // Renders the components
  render(){
    let class_name = 'dialog-body-no-footer';
    if( this.state.tab === 0 ){
      class_name = 'dialog-body-inputs-no-footer'; 
    }
    if( this.state.tab === 5 ){
      class_name = 'pgmlinks-dialog-body'; 
    }
    if( this.state.hasError === false ) {
      return (
        <Dialog width={this.state.width} height={this.state.height} show={this.state.show} >
          <DialogHeader caption={this.state.caption} closeButton onClose={this.onCancel} />
          <DialogBody className={class_name}>
            {this.props.children}
          </DialogBody>
        </Dialog>
      );
    } else {
      return ( <span></span> );
    }
  }
}

// Displays a copy dialog prompt, this can be seen in ProgramInputs when the copy button
// is pressed on an existing row.
export class CopyFromItemDialog extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      show: props.show === undefined ? false: props.show,
      onCancel: props.onCancel,
      onConfirm: props.onConfirm,
      message: props.message,
      header: props.header,
      clearheader: props.clearheader
    };

    // Bindings
    this.onCancel = this.onCancel.bind( this );
    this.onConfirm = this.onConfirm.bind( this );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      show: nextProps.show,
      onCancel: nextProps.onCancel,
      onConfirm: nextProps.onConfirm,
      message: nextProps.message,
      header: nextProps.header,
      clearheader: nextProps.clearheader
    } );
  }

  onCancel( e ){
    if( this.state.onCancel !== undefined ){
      this.state.onCancel();
    }
  }

  onConfirm( e ){
    if( this.state.onConfirm !== undefined ){
      this.state.onConfirm( e );
    }
  }

  render(){

    let message = this.state.message;
    let header = this.state.header;
    let header_message = 'Copy From ';

    if( message === undefined ){
      message = 'Pass a message in';
    }

    if( header === undefined ){
      header = '';
    }

    // Allows the header to be anything, removes the Copy From prefix
    if( this.state.clearheader === true ){
      header_message = '' + header;
    } else {
      header_message = header_message + header;
    }

    if( this.state.show === true ){
      return (
        <div className="dialog" style={{top: '30%', left: '30%', right: '30%', bottom:'40%'}}>
          <div className="dialog-header">
            <span>{header_message}</span>
            <span className='dialog-header-close-button' onClick={this.onCancel} >
              <i className="icon-fontello-cancel" />
            </span>
          </div>
          <div className="dialog-body">
            <div style={{padding:'20px',height:'100%',width:'100%'}}>
              <span style={{'color':'black'}}>{message}</span>
            </div>
          </div>
          <div className="dialog-footer" style={{'bottom': '5px'}}>
            <button className='dialog-cancel-button' key='btn-sub-dialog-save' onClick={this.onCancel}>Cancel</button>
            <button className='dialog-save-button' key='btn-sub-dialog-cancel' onClick={this.onConfirm}>Confirm</button>
          </div>
        </div>
      );
    } else {
      return ( <span></span> );
    }
  }
}

export default ProgramDialog;


// WEBPACK FOOTER //
// ./src/presentation/ProgramDialog.js